import axios from '@/api/config';
const classInfo = {
  addClassInfo(data) {
    return axios.post(`${process.env.BASE_URL}/classInfo/addClassInfo`, data)
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/classInfo/pageList`, data)
  },
  checkPermission(data) {
    return axios.get(`${process.env.BASE_URL}/classInfo/checkPermission`, {
      params: data
    })
  },
  getClassInfoDetail(data) {
    return axios.get(`${process.env.BASE_URL}/classInfo/getClassInfoDetail`, {
      params: data
    })
  },
  getClassInfo(data) {
    return axios.get(`${process.env.BASE_URL}/classInfo/getClassInfo`, {
      params: data
    })
  },
  getClassInfoList(data) {
    return axios.get(`${process.env.BASE_URL}/classInfo/getClassInfoList`, {
      params: data
    })
  },
  getClassInfoTree(data) {
    return axios.get(`${process.env.BASE_URL}/classInfo/getClassInfoTree`, {
      params: data
    })
  },
  getScheduleInfo(data) {
    return axios.post(`${process.env.BASE_URL}/classInfo/getScheduleInfo`, data)
  },
  scheduleCalendar(data) {
    return axios.post(`${process.env.BASE_URL}/classInfo/scheduleCalendar`, data)
  },
  classroomCalendar(data) {
    return axios.post(`${process.env.BASE_URL}/classInfo/classroomCalendar`, data)
  },
  generateSimpleClassInfoSchedule(data) {
    return axios.post(`${process.env.BASE_URL}/classInfo/generateSimpleClassInfoSchedule`, data)
  },
  deleteClassInfo(data) {
    return axios.delete(`${process.env.BASE_URL}/classInfo/deleteClassInfo`, {
      data: data
    })
  },
  updateClassInfo(data) {
    return axios.put(`${process.env.BASE_URL}/classInfo/updateClassInfo`, data)
  },
  regenerateSimpleClassInfoSchedule(data) {
    return axios.post(`${process.env.BASE_URL}/classInfo/regenerateSimpleClassInfoSchedule`, data);
  },
  checkSchedulePermission(data) {
    return axios.post(`${process.env.BASE_URL}/classInfo/checkSchedulePermission`, data);
  },
  getClassLogDataList(data) {
    return axios.post(`${process.env.BASE_URL}/commonDataStatistics/pageList`, data);
  },
  updateCommonDataStatistics(data) {
    return axios.post(`${process.env.BASE_URL}/commonDataStatistics/updateCommonDataStatistics`, data);
  },
  getCommonDataStatistics(data) {
    return axios.get(`${process.env.BASE_URL}/commonDataStatistics/getCommonDataStatistics`, {
      params: data
    });
  },
  getUserActionLog(data) {
    return axios.post(`${process.env.BASE_URL}/commonDataStatisticsLog/pageList`, data);
  },
  getFlashSaleGoodsList(data) {
    return axios.get(
      `${process.env.BASE_URL}/schoolPage/getFlashSaleGoodsList`, {
        params: data
      }
    );
  },
  deleteActivity(data) {
    return axios.delete(`${process.env.BASE_URL}/activity/deleteActivity`, {
      data: data
    });
  },
  activityPageList(data) {
    return axios.post(`${process.env.BASE_URL}/activity/pageList`, data);
  },
  addActivity(data) {
    return axios.post(`${process.env.BASE_URL}/activity/addActivity`, data);
  },
  updateActivity(data) {
    return axios.put(`${process.env.BASE_URL}/activity/updateActivity`, data);
  },
  getActivityById(data) {
    return axios.get(`${process.env.BASE_URL}/activity/getActivity`, {
      params: data
    });
  },

  getDiscountCoupon(data) {
    return axios.get(`${process.env.BASE_URL}/discountCoupon/getDiscountCoupon/${data}`);
  },
  getDiscountCouponPage(data) {
    return axios.get(`${process.env.BASE_URL}/discountCoupon/getDiscountCouponPage`, {
      params: data
    });
  },
  addDiscountCoupon(data) {
    return axios.post(`${process.env.BASE_URL}/discountCoupon/addDiscountCoupon`, data);
  },
  updateDiscountCoupon(data) {
    return axios.post(`${process.env.BASE_URL}/discountCoupon/updateDiscountCoupon`, data);
  },
  deleteDiscountCouponList(data) {
    return axios.delete(`${process.env.BASE_URL}/discountCoupon/deleteDiscountCouponList`, {
      data: data
    });
  },
  activityBatchOn(data) {
    return axios.post(`${process.env.BASE_URL}/activity/activityBatchOn`, data);
  },
  activityBatchOff(data) {
    return axios.post(`${process.env.BASE_URL}/activity/activityBatchOff`, data);
  },
  addActivityBatch(data) {
    return axios.post(`${process.env.BASE_URL}/activity/addActivityBatch`, data);
  },
  batchUpdateActivity(data) {
    return axios.put(`${process.env.BASE_URL}/activity/batchUpdateActivity`, data)
  },
}
export default classInfo



// WEBPACK FOOTER //
// ./src/api/classInfo.js